import { encode, decode } from 'rison';
import { pick, isNil } from 'ramda';
import { isNilOrEmpty } from './stringUtils.js';

const encodeToJSR = jsrStr => encode(jsrStr).replace(/#/g, '*hash*');
const decodeJSR = jsrStr => {
  try {
    return decode(decodeURIComponent(jsrStr).replace(/\*hash\*/g, '#'));
  } catch (e) {
    return {};
  }
};

/**
 * Creates an object composed of the URL parameters extracted from queryStr.
 * Optionally return specific properties.
 *
 * @param {String} queryStr The source string.
 * @param {Array} specificProperties The properties to pick.
 * @returns {Object} Returns
 */
const getParams = function (queryStr) {
  let specificProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const paramObj = {};
  const paramsArr = decodeURIComponent(queryStr).replace(/^\?/, '').split('&');
  paramsArr.forEach(pair => {
    const pairArr = pair.split('=');
    if (!isNilOrEmpty(pairArr[0])) {
      paramObj[pairArr[0]] = decodeURIComponent(pairArr[1] || '');
    }
  });

  // convert JSR string into object
  if (Object.prototype.hasOwnProperty.call(paramObj, 'jsr')) {
    paramObj.jsr = decodeJSR(paramObj.jsr);
  }
  return specificProperties.length === 0 ? paramObj : pick(specificProperties, paramObj);
};
const convertParamObjToStr = paramObj => {
  const updatedParamObj = {
    ...paramObj,
    jsr: encodeToJSR(paramObj.jsr).replace(/#/g, '*hash*')
  };
  let paramString = '?';
  Object.keys(updatedParamObj).forEach(param => {
    paramString += `${param}=${updatedParamObj[param]}&`;
  });

  // trim trailing ampersand
  paramString = paramString.slice(0, paramString.length - 1);
  return paramString;
};
const getJSR = jsrStr => getParams(jsrStr).jsr;

// See paramsObj below
const getNewQueryStr = function (queryStr) {
  let paramsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Returns an updated query string with data from paramsArr
  const updatedParamObj = {
    ...getParams(queryStr),
    ...paramsObj
  };
  return convertParamObjToStr(updatedParamObj);
};
const getValueFromJsr = function (key) {
  let searchString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const queryString = searchString || window.location.search;
  const {
    jsr
  } = getParams(queryString);
  return jsr === undefined ? null : jsr[key];
};
const pushParamsToJSR = function (queryStr) {
  let paramsArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const paramObj = getParams(queryStr);

  // JSR is expected to be an object
  if (isNil(paramObj.jsr)) {
    paramObj.jsr = {};
  }
  paramsArr.forEach(param => {
    if (!isNil(paramObj[param])) {
      paramObj.jsr[param] = decodeURIComponent(paramObj[param]);
      try {
        paramObj.jsr[param] = JSON.parse(paramObj.jsr[param]);
      } catch (e) {
        // parameter cannot be parsed as JSON
      }
      delete paramObj[param];
    }
  });
  return convertParamObjToStr(paramObj);
};

export { convertParamObjToStr, decodeJSR, encodeToJSR, getJSR, getNewQueryStr, getParams, getValueFromJsr, pushParamsToJSR };
//# sourceMappingURL=jsr.js.map
